import { create } from "zustand";
import axiosInstance from '../../api/axiosInstance';
import Base64e from "../../components/encodedecode/encode";



interface Section {
  id: number;
  name: string;
  content: string;
  
}

interface HomeState {
    staticpage: Record<string, Section>;
  fetchStaticPageContent: (id:number) => void;
}

const useTermStore = create<HomeState>((set) => ({
    staticpage: {},
  fetchStaticPageContent: async (id) => {
    try {
        const response = await axiosInstance.post('getPage', {
            id: Base64e.encode(id + ''),
          });
        set({ staticpage: response.data });
      } catch (error) {
        console.error('Failed to fetch blogs:', error);
      }
  },
}));


export default useTermStore;








